import { Injectable } from '@angular/core';
import { AccountRepoService } from '@client/app/services/api/account-repo/account-repo.service';
import { CustomerInterface } from '@monsido/ng2/modules/models/api/interfaces/customer.interface';
import { Customer } from '@monsido/ng2/modules/models/api/customer';

@Injectable({
    providedIn: 'root',
})
export class AccountService {

    constructor (private accountRepoService: AccountRepoService) {}

    update (data: CustomerInterface, headers?: any): Promise<Customer> {
        return this.accountRepoService.update(data);
    }
}
